<template>
  <a-card :bordered="false">
    <div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker v-model="queryParam.createdate"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="Recharge()">在线充值</a-button>
      </div>
      <s-table
        ref="table"
        size="default"
        rowKey="u_sellercharge_id"
        :columns="columns"
        :data="loadData"
      >
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="paytype" slot-scope="text">
          <!-- 1.支付宝web扫码支付
          2.微信web扫码支付
          3.支付宝app支付
          4.微信app支付
          5.余额支付
          6.微信原生app支付
          7.微信小程序支付
          8.支付宝原生app支付
          9.现金支付
          10.云商通支付-微信app支付
          11.云商通支付-微信小程序
          12.云商通支付-支付宝app支付-->
          <!-- https://vue.ant.design/components/icon-cn/ -->
          <div style=" font-size: x-large; ">
            <a-tooltip placement="top" v-if="text==1">
              <template slot="title">
                <span>支付宝web扫码支付</span>
              </template>
              <a-icon type="alipay"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==2">
              <template slot="title">
                <span>微信web扫码支付</span>
              </template>
              <a-icon type="wechat"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==3">
              <template slot="title">
                <span>支付宝app支付</span>
              </template>
              <a-icon type="alipay"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==4">
              <template slot="title">
                <span>微信app支付</span>
              </template>
              <a-icon type="money-collect"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==5">
              <template slot="title">
                <span>余额支付</span>
              </template>
              <a-icon type="money-collect"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==6">
              <template slot="title">
                <span>微信原生app支付</span>
              </template>
              <a-icon type="wechat"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==7">
              <template slot="title">
                <span>微信小程序支付</span>
              </template>
              <a-icon type="wechat"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==8">
              <template slot="title">
                <span>支付宝原生app支付</span>
              </template>
              <a-icon type="alipay"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==9">
              <template slot="title">
                <span>现金支付</span>
              </template>
              <a-icon type="dollar"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==10">
              <template slot="title">
                <span>云商通支付-微信app支付</span>
              </template>
              <a-icon type="wechat"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==11">
              <template slot="title">
                <span>云商通支付-微信小程序</span>
              </template>
              <a-icon type="wechat"/>
            </a-tooltip>
            <a-tooltip placement="top" v-if="text==12">
              <template slot="title">
                <span>云商通支付-支付宝app支付</span>
              </template>
              <a-icon type="alipay"/>
            </a-tooltip>
          </div>
        </span>
      </s-table>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import STable from '@/components/Table/'
import { getRechargList } from '@/api/SellerCoupons'
import { getLocalTime } from '@/utils/util.js'

export default {
  components: {
    STable
  },
  data() {
    return {
      // 查询参数
      queryParam: { createdate: '' },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '充值订单号',
          dataIndex: 'tradeno',
          customRender: text => (text ? text : '-')
        },
        {
          title: '充值金额（￥）',
          dataIndex: 'realpay',
          customRender: text => (text ? text : '-')
        },
        {
          title: '实际支付金额（￥）',
          dataIndex: 'payment',
          customRender: text => (text ? text : '-')
        },
        {
          title: '支付时间',
          dataIndex: 'paydate',
          customRender: text => getLocalTime(text, 'YYYY-MM-DD H:m:s')
        },
        {
          title: '支付方式',
          dataIndex: 'paytype',
          scopedSlots: { customRender: 'paytype' }
        },
        {
          title: '创建时间',
          dataIndex: 'createdate',
          customRender: text => getLocalTime(text)
        },
        {
          title: '备注',
          dataIndex: 'memo'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        //this.queryParam为V-model的提交参数集合
        //需要提交的参数集合
        var paraData = {}
        if (this.queryParam.createdate) {
          //格式化时间
          this.queryParam.createdate[0] = moment(this.queryParam.createdate[0]).format('YYYY-MM-DD')
          this.queryParam.createdate[1] = moment(this.queryParam.createdate[1]).format('YYYY-MM-DD')

          paraData['dateStart'] = this.queryParam.createdate[0]
          paraData['dateEnd'] = this.queryParam.createdate[1]
        }

        //https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
        //Object.assign() 方法用于将所有可枚举属性的值从一个或多个源对象复制到目标对象。它将返回目标对象。
        return getRechargList(Object.assign(parameter, paraData)).then(res => {
          return res.result
        })
      }
    }
  },
  methods: {
    Recharge() {
      this.$emit('onRecharge')
    }
  }
}
</script>
